import { render, staticRenderFns } from "./platformRefundRecordModal.vue?vue&type=template&id=358ca88c&"
import script from "./platformRefundRecordModal.vue?vue&type=script&lang=js&"
export * from "./platformRefundRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports